var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99996 2.00002C3.79082 2.00002 1.99996 3.79088 1.99996 6.00002C1.99996 8.20916 3.79082 10 5.99996 10C8.2091 10 9.99996 8.20916 9.99996 6.00002C9.99996 3.79088 8.2091 2.00002 5.99996 2.00002ZM0.666626 6.00002C0.666626 3.0545 3.05444 0.666687 5.99996 0.666687C8.94548 0.666687 11.3333 3.0545 11.3333 6.00002C11.3333 8.94554 8.94548 11.3334 5.99996 11.3334C3.05444 11.3334 0.666626 8.94554 0.666626 6.00002Z",
    fill: "#B6B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 10.0667C9.33329 9.66168 9.66162 9.33335 10.0666 9.33335H11.2963C11.4904 9.33335 11.6766 9.41033 11.8141 9.54741L15.0897 12.8137C15.3785 13.1018 15.3768 13.5702 15.0858 13.8561L13.8242 15.0957C13.5364 15.3785 13.0742 15.3757 12.7898 15.0894L9.54624 11.8226C9.40984 11.6852 9.33329 11.4995 9.33329 11.3059V10.0667Z",
    fill: "#B6B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0de2dc2e9a92104a89c108e452cd0c64.svg";
export { ForwardRef as ReactComponent };